import { IsString, Length } from 'class-validator';

export class NewCollectorDto {
  @IsString()
  @Length(3, 50, {
    message: 'Collector name length should be between 5 and 50 characters',
  })
  name: string;
}
